const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getWalletTransactions = async (
  walletId,
  page = 1,
  itemsPerPage = 10,
  sortBy = 'created_at',
  sortOrder = 'desc',
  startDate,
  endDate
) => {
  try {
    const order_by = sortOrder === "asc" ? sortBy : `-${sortBy}`;

    const token = localStorage.getItem("authToken");

    const params = new URLSearchParams({
      page,
      items: itemsPerPage,
      order_by
    });

    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);

    const response = await fetch(
      `${BASE_URL}/eci/apis/v4/wallets/${walletId}/get_transaction_list?${params.toString()}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch transactions");
    }

    const data = await response.json();
    return {
      items: data.msg?.items || [],
      pagination: data.msg?.pagination || {}
    };
  } catch (error) {
    console.error("Error fetching wallet transactions:", error);
    throw error;
  }
};
